import { render, staticRenderFns } from "./CompliantsCombobox.vue?vue&type=template&id=4c05b342&"
import script from "./CompliantsCombobox.vue?vue&type=script&lang=ts&"
export * from "./CompliantsCombobox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports